import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { ComponentPropsWithRef } from '../../types/utils';
import { getInputClassName, InputClassProps } from '../input-class-name.util';

export type InputProps = ComponentPropsWithRef<'input'> & InputClassProps;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  {
    height,
    type = 'text',
    variant,
    className,
    disabled,
    readOnly,
    hasError = false,
    fullWidth = true,
    children,
    ...rest
  },
  ref
) {
  return (
    <input
      ref={ref}
      type={type}
      disabled={disabled}
      readOnly={readOnly}
      aria-invalid={hasError || undefined}
      className={classNames(
        getInputClassName({
          variant,
          disabled: disabled || readOnly,
          hasError,
          fullWidth,
          height,
        }),
        className
      )}
      {...rest}
    >
      {children}
    </input>
  );
});
